import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/settings/api-access.svg'


const _withScopeId = n => (_pushScopeId("data-v-69dbdb40"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testid"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "api-access",
  width: "154"
}, null, -1))
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = { class: "font-gordita-bold text-[24px] leading-[32px] text-Text/Dark" }
const _hoisted_5 = { class: "font-gordita-regular text-[14px] leading-[19px] mb-[32px] text-Text/text_medium" }
const _hoisted_6 = { class: "flex gap-[8px] items-center" }
const _hoisted_7 = {
  key: 1,
  class: "icon-uil uil-plus !mr-0"
}

import elementIds from '@/const/elementIds.json';
import { IncrediButton, useIncrediDialog } from 'incredi-ui';
import { useApiAccess } from '@/views/settings/settingsApiAccess/settingsApiAccess.helpers';
import addAPIKeyDialog from './components/addAPIKeyDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'emptyApiKey',
  setup(__props) {

const { GQL_MUTATION_CreateKey } = useApiAccess();
const dialog = useIncrediDialog();

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    "data-testid": _unref(elementIds).settings.apiKeys.emptyTableView,
    class: "empty-api-key"
  }, [
    _hoisted_2,
    _createElementVNode("div", {
      "data-testid": _unref(elementIds).settings.apiKeys.emptyApiKey.description,
      class: "empty-api-key--content-wrapper"
    }, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('settings.apiAccess.title')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('settings.apiAccess.description')), 1)
    ], 8, _hoisted_3),
    _createVNode(_unref(IncrediButton), {
      rounded: true,
      design: "primary-green",
      size: "small",
      "data-testid": _unref(elementIds).settings.apiKeys.emptyApiKey.generateKeyButton,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(dialog)?.open('addAPIKeyDialog', addAPIKeyDialog, {})), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_unref(GQL_MUTATION_CreateKey).loading.value)
            ? (_openBlock(), _createBlock(_component_q_spinner, {
                key: 0,
                color: "white",
                size: "16px"
              }))
            : (_openBlock(), _createElementBlock("i", _hoisted_7)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.apiAccess.generateButton')), 1)
        ])
      ]),
      _: 1
    }, 8, ["data-testid"])
  ], 8, _hoisted_1))
}
}

})